import { render, staticRenderFns } from "./LifeinsuranceArrangedBy.vue?vue&type=template&id=58ec99e0"
import script from "./LifeinsuranceArrangedBy.vue?vue&type=script&lang=js"
export * from "./LifeinsuranceArrangedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports